module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "option mobile-hide",
    attrs: {
      "to": {
        name: 'boxEdit',
        params: {
          locale: _vm.i18n.locale,
          boxId: _vm.box.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-edit"
  }), _vm._v(" " + _vm._s(_vm.$t('general.actions.edit')) + " Box\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-278ec70d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/EditBox.vue
 ** module id = 784
 ** module chunks = 1
 **/